import React from 'react';
// Import Components
import Title from './Title';
import Services from './Services';
import Features from './Features';
import Testimonials from './Testimonials';
import ContactForm from './Contact';
import ContactUs from './ContactUs';

const Home = () => {


  return (
        <>
            <Title />
            <Services />
            <Features />
            <Testimonials /> 
            <ContactForm />
            <ContactUs />
        </>
  );
};

export default Home;
